import React from "react";
import { Box, Typography } from "@mui/material";
import { CERTAINTY, SEVERITY, URGENCY } from "../UserVisibleStrings";

type AlertInfoTableProps = {
    headline: string,
    severity?: string,
    urgency?: string,
    certainty?: string,
};

export const AlertInfoTable: React.FC<AlertInfoTableProps> = ( { headline, severity, urgency, certainty } ) => (
    <Box sx = {{ mb: 1 }}>
        <Typography variant = "body2" sx = {{ fontWeight: "bold", mb: 0.5 }}>
            {headline}
        </Typography>
        <Box display = "grid" gridTemplateColumns = "auto 1fr" rowGap = {0.5} columnGap = {1}>
            <Typography variant = "body2" color = "text.secondary">{SEVERITY}:</Typography>
            <Typography variant = "body2">{severity}</Typography>

            <Typography variant = "body2" color = "text.secondary">{URGENCY}:</Typography>
            <Typography variant = "body2">{urgency}</Typography>

            <Typography variant = "body2" color = "text.secondary">{CERTAINTY}:</Typography>
            <Typography variant = "body2">{certainty}</Typography>
        </Box>
    </Box>
);
